export default (sitemap: SitemapBuilder) =>
{
    sitemap.before('[[[Moduły]]]', [
        {
            name: '[[[Platforma rozliczeniowa]]]',
            short: '[[[Platforma]]]',
            icon: 'fa-brands fa-galactic-senate',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Md',
            children: [
                {
                    name: '[[[Programy/Usługi]]]',
                    icon: 'far fa-fw fa-star',
                    route: 'md-programs',
                    auth: { all: ['ProgramsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opisu usługi]]]',
                            route: 'md-programs-add',
                            auth: { all: ['ProgramsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opisu usługi]]]',
                            route: 'md-programs-edit',
                            auth: { all: ['ProgramsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Importy danych]]]',
                    icon: 'far fa-fw fa-solid fa-upload',
                    auth: { all: ['DataImportsPermissions@View'], any: [] },
                    route: 'md-data-imports',
                    children: [
                        {
                            name: '[[[Dodanie importu]]]',
                            route: 'md-data-imports-add',
                            auth: { all: [], any: ['DataImportsPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Logi importu]]]',
                            route: 'md-data-imports-logs',
                            auth: { all: [], any: ['DataImportsPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Quizy]]]',
                    icon: 'far fa-fw fa-solid fa-square-poll-horizontal',
                    auth: { all: ['QuizzesPermissions@View'], any: [] },
                    route: 'md-quizzes',
                    children: [
                        {
                            name: '[[[Dodanie quizu]]]',
                            route: 'md-quizzes-add',
                            auth: { all: [], any: ['QuizzesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja quizu]]]',
                            route: 'md-quizzes-edit',
                            auth: { all: [], any: ['QuizzesPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Wyniki]]]',
                            route: 'md-quizzes-results',
                            auth: { all: ['QuizzesPermissions@ViewResults'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Podejście]]]',
                            route: 'md-quizzes-result',
                            auth: { all: ['QuizzesPermissions@ViewResults'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Pytania]]]',
                            route: 'md-quizzes-questions',
                            auth: { all: ['QuizzesPermissions@ViewQuestions'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie pytania]]]',
                            route: 'md-quizzes-question-add',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja pytania]]]',
                            route: 'md-quizzes-questions-edit',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie pytania]]]',
                            route: 'md-quizzes-questions-add',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie teorii]]]',
                            route: 'md-quizzes-theory-add',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja teorii]]]',
                            route: 'md-quizzes-theory-edit',
                            auth: { all: ['QuizzesPermissions@EditQuestion'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Firmy]]]',
                    icon: 'far fa-fw fa-solid fa-building',
                    route: 'md-companies',
                    auth: { all: ['CompaniesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie firmę]]]',
                            route: 'md-companies-add',
                            auth: { all: ['CompaniesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja firmy]]]',
                            route: 'md-companies-edit',
                            auth: { all: ['CompaniesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[POP]]]',
                    icon: 'far fa-fw fa-solid fa-building-user',
                    route: 'md-branches',
                    auth: { all: ['BranchesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie POP]]]',
                            route: 'md-branches-add',
                            auth: { all: ['BranchesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja POP]]]',
                            route: 'md-branches-edit',
                            auth: { all: ['BranchesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Dokumenty rozliczeniowe]]]',
                    icon: 'far fa-fw fa-solid fa-file',
                    route: 'md-sale-reports',
                    auth: { all: ['SaleReportsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie dokumentu rozliczeniowego]]]',
                            route: 'md-sale-reports-add',
                            auth: { all: ['SaleReportsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja dokumentu rozliczeniowego]]]',
                            route: 'md-sale-reports-edit',
                            auth: { all: ['SaleReportsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Formularz kontaktowy]]]',
                    icon: 'far fa-fw fa-solid fa-file',
                    auth: { all: ['ContactFormEntriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Zgłoszenia]]]',
                            route: 'md-contact-form',
                            auth: { all: ['ContactFormEntriesPermissions@View'], any: [] },
                            visible: true
                        },
                        {
                            name: '[[[Ustawienia]]]',
                            route: 'md-contact-form-configuration',
                            auth: { all: ['ContactFormEntriesPermissions@View'], any: [] },
                            visible: true
                        },
                        {
                            name: '[[[Podgląd zgłoszenia]]]',
                            route: 'md-contact-form-edit',
                            auth: { all: ['ContactFormEntriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Szkolenia]]]',
                    icon: 'far fa-fw fa-solid fa-square-poll-horizontal',
                    auth: { all: ['CoursesPermissions@View'], any: [] },
                    route: 'md-courses',
                    children: [
                        {
                            name: '[[[Dodanie szkolenia]]]',
                            route: 'md-courses-add',
                            auth: { all: [], any: ['CoursesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Konfiguracja]]]',
                            route: 'md-courses-configuration',
                            auth: { all: [], any: ['CoursesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja szkolenia]]]',
                            route: 'md-courses-edit',
                            auth: { all: [], any: ['CoursesPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Tematy]]]',
                            route: 'md-course-subjects',
                            auth: { all: [], any: ['CourseSubjectsPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Dodaj temat]]]',
                            route: 'md-course-subjects-add',
                            auth: { all: [], any: ['CourseSubjectsPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja tematu]]]',
                            route: 'md-course-subjects-edit',
                            auth: { all: [], any: ['CourseSubjectsPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Moduły]]]',
                            route: 'md-course-modules',
                            auth: { all: [], any: ['CourseModulesPermissions@View'] },
                            visible: false
                        },
                        {
                            name: '[[[Dodaj moduł]]]',
                            route: 'md-course-modules-add',
                            auth: { all: [], any: ['CourseModulesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja modułu]]]',
                            route: 'md-course-modules-edit',
                            auth: { all: [], any: ['CourseModulesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Wyniki]]]',
                            route: 'md-course-modules-results',
                            auth: { all: [], any: ['CourseModulesPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Paczki SCORM]]]',
                    icon: 'fas fa-fw fa-book-open',
                    auth: { all: ['ScormPackagesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista paczek SCORM]]]',
                            route: 'md-scorm-scormpackages',
                            icon: 'fas fa-fw fa-grip-vertical',
                            auth: { all: ['ScormPackagesPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie paczki SCORM]]]',
                                    route: 'md-scorm-scormpackages-add',
                                    auth: { all: ['ScormPackagesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja paczek SCORM]]]',
                                    route: 'md-scorm-scormpackages-edit',
                                    auth: { all: ['ScormPackagesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[EditoUser]]]',
                    visible: false,
                    auth: { all: ['EditoUsersPermissions@AccountsPermissions', 'EditoUsersPermissions@AccountsPats', 'EditoUsersPermissions@AccountsRegulations', 'EditoUsersPermissions@AccountsInspection'], any: [] }
                }
            ]
        }
    ]);
};
